// Next-games payload schema (`ItemsData<NextGameData>`, GET /players/{slug}/next-games).
// `key` is required: it is the stable Sorare game id used as the React row key, and the
// API always emits it (a row without it is a genuine contract violation, same reasoning
// as the required `updated` leaf in stats.ts). All other leaves are `nullish` per the
// looseObject + nullish convention documented in common.ts.

import * as v from 'valibot';
import { itemsDataSchema } from './common';

export const nextGameSchema = v.looseObject({
  key: v.string(),
  matchDate: v.nullish(v.string()),
  gameWeek: v.nullish(v.string()),
  isClubGame: v.nullish(v.boolean()),
  competitionName: v.nullish(v.string()),
  homeTeam: v.nullish(v.string()),
  awayTeam: v.nullish(v.string()),
  playerTeam: v.nullish(v.string()),
  isHome: v.nullish(v.boolean()),
});

export const nextGamesSchema = itemsDataSchema(nextGameSchema);
